import { css, SerializedStyles } from "@emotion/react"

export const injectMobileStyle = (style: SerializedStyles) =>
  css`
    @media only screen and (max-width: 768px) {
      ${style}
    }
  `
